/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_PublishedInputs */

const en_legal_published = /** @type {((inputs: Legal_PublishedInputs) => LocalizedString) & { parts: (inputs: Legal_PublishedInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Legal_PublishedInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Published `)
		}),
		{
			parts: /** @type {(inputs: Legal_PublishedInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Published " }, { type: "markup-standalone", name: "published", options: {}, attributes: {} }])
			})
		}
	)
);

const zh_legal_published = /** @type {((inputs: Legal_PublishedInputs) => LocalizedString) & { parts: (inputs: Legal_PublishedInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Legal_PublishedInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`发布于 `)
		}),
		{
			parts: /** @type {(inputs: Legal_PublishedInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "发布于 " }, { type: "markup-standalone", name: "published", options: {}, attributes: {} }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Legal_PublishedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const legal_published = /** @type {((inputs?: Legal_PublishedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & { parts: (inputs?: Legal_PublishedInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Legal_PublishedInputs, { locale?: "en" | "zh" }, { published: { options: {}; attributes: {}; children: false } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Legal_PublishedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh") return zh_legal_published(inputs)
			return en_legal_published(inputs)
		}),
		{
			parts: /** @type {(inputs?: Legal_PublishedInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh") return /** @type {{ parts?: (inputs: Legal_PublishedInputs) => import('../runtime.js').MessagePart[] }} */ (zh_legal_published).parts?.(inputs) ?? [{ type: "text", value: zh_legal_published(inputs) }]
				return /** @type {{ parts?: (inputs: Legal_PublishedInputs) => import('../runtime.js').MessagePart[] }} */ (en_legal_published).parts?.(inputs) ?? [{ type: "text", value: en_legal_published(inputs) }]
			})
		}
	)
);